import { ActionContext, ActionStatus } from '@ngxs/store/src/actions-stream';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ActionClass } from '../state';

export const filterDispatchedAction =
  <T extends object>(actions: ActionClass<T>[]) =>
  (obs$: Observable<ActionContext>): Observable<T> =>
    obs$.pipe(
      filter(context => context.status === ActionStatus.Dispatched),
      map(context => context.action),
      filter(dispatchedAction => actions.includes(Object.getPrototypeOf(dispatchedAction).constructor))
    );
